import { Component } from "react";

// Garde-fou d'affichage : si un écran plante, on montre un message lisible
// (et le détail technique) au lieu d'une page vide.
export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { erreur: null };
  }

  static getDerivedStateFromError(erreur) {
    return { erreur };
  }

  componentDidCatch(erreur, infos) {
    console.error("Erreur d'écran :", erreur, infos);
  }

  render() {
    if (this.state.erreur) {
      return (
        <main style={{ fontFamily: "Arial, sans-serif", padding: "32px", color: "#111" }} data-testid="erreur-ecran">
          <h1 style={{ fontSize: "22px", color: "#b3261e" }}>Un problème est survenu dans cette partie de l'application.</h1>
          <p>Rechargez la page (Ctrl+Maj+R). Si le problème persiste, signalez ce message :</p>
          <pre style={{ background: "#f6f6f6", border: "1px solid #ddd", padding: "12px", whiteSpace: "pre-wrap" }}>
            {String(this.state.erreur && (this.state.erreur.stack || this.state.erreur.message || this.state.erreur))}
          </pre>
        </main>
      );
    }
    return this.props.children;
  }
}
